import './CellContent.css';

import { memo, useEffect, useRef, useState } from 'react';

export interface CellContentProps {
  value: string;
  highlightDanger?: boolean;
}

const CellContent = ({ value, highlightDanger = false }: CellContentProps) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [hasOverflow, setHasOverflow] = useState<boolean>(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const resizeObserver = new ResizeObserver(() => {
      setHasOverflow(el.scrollWidth > el.clientWidth);
    });
    resizeObserver.observe(el);
    return () => resizeObserver.disconnect();
  }, []);

  return (
    <span
      data-pr-tooltip={hasOverflow ? value : undefined}
      className={`cell-content${highlightDanger ? ' cell-content_negative' : ''}`}
      data-text={value}
      ref={ref}
    >
      {value}
    </span>
  );
};

export default memo(CellContent);
